import { CancellationReasonDTO } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import { FormSelectInput } from "apps/portal/src/components/atoms";
import useGymflowModels from "apps/portal/src/store";
import { clubAsMemberQueryKeys } from "libs/api/src/lib/hooks/clubAsMember/clubAsMemberQueryKeys";
import { useTranslation } from "react-i18next";

import { CancelMembershipFormValues } from "../types";

export const FormCancellationReasonAsMemberSelect = () => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();

  return (
    <FormSelectInput<CancelMembershipFormValues, number>
      name="cancellationReason"
      label={t(
        "page.hostedPagesProfileCancelMembership.form.cancellationReason",
      )}
      isMulti={false}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: clubAsMemberQueryKeys.cancellationReason(),
          queryFn: async () =>
            (await api.customerClubApi.cancellationReason()).data,
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              CancellationReasonDTO[]
            >;

            const transformedPages = pages.map((page) =>
              page.map(({ id, name }) => ({
                id,
                label: name,
                value: id,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          initialPageParam: undefined,
          getNextPageParam: () => undefined,
        })
      }
    />
  );
};
